import axios from 'axios';
import backendUrl from '../store/config';
import { store } from '../store';
import { logout } from '../store/slices/authSlice';
import ConnectionMonitor from './connectionMonitor';

// Create axios instance
const apiClient = axios.create({
  baseURL: backendUrl,
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('aihub_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration and authentication errors
apiClient.interceptors.response.use(
  (response) => {
    // Report successful connection
    ConnectionMonitor.getInstance().reportConnectionSuccess();
    return response;
  },
  (error) => {
    // Check if this is a network/connection error
    if (!error.response || error.code === 'ECONNREFUSED' || error.code === 'NETWORK_ERROR') {
      ConnectionMonitor.getInstance().reportConnectionError();
    } else {
      // If we got a response, the connection is working
      ConnectionMonitor.getInstance().reportConnectionSuccess();
    }
    if (error.response?.status === 401) {
      // Only handle logout if we're not already on the login or register page
      const currentPath = window.location.pathname;
      if (currentPath !== '/login' && currentPath !== '/register') {
        // Determine appropriate user-friendly message based on error details
        let message = 'Your session has expired. Please log in again.';
        
        // Check if it's a credentials validation error
        if (error.response?.data?.detail === 'Could not validate credentials') {
          message = 'Your session is no longer valid. Please log in again to continue.';
        } else if (error.response?.data?.detail === 'Incorrect email or password') {
          message = 'Authentication failed. Please check your credentials and try again.';
        } else if (error.response?.data?.detail?.includes('token')) {
          message = 'Your login session has expired. Please sign in again.';
        }
        
        // Store the message in sessionStorage to show on login page
        sessionStorage.setItem('sessionExpiredMessage', message);
        
        // Dispatch logout action to clear Redux state
        store.dispatch(logout());
        
        // Redirect to login with a slight delay to ensure state is updated
        setTimeout(() => {
          window.location.href = '/login';
        }, 100);
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;